@if (riskLevel(); as riskLevel) {
  <span [ngStyle]="{ color: riskLevel === 'unset' ? null : riskColors[riskLevel] }">
    <i
      class="fa"
      [class.fa-fw]="fixedWidth()"
      [class.fa-circle]="riskLevel !== 'unset'"
      [class.fa-circle-o]="riskLevel === 'unset'"
      [ngStyle]="{ color: riskLevel === 'unset' ? null : disabled() ? disabledItemColor : riskColors[riskLevel] }"></i>
  </span>
}
